import axios from "../../axios";

const getLogs = async function (accessToken,params = {}) {
    try {
        const response = await axios.post('admin/log-webhook/getLogs', params ,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default getLogs;
